import React from 'react'
import { Box, Grid, Skeleton, useMediaQuery, useTheme } from '@mui/material'

const InstallationFormLoadingSkeleton: React.FC = () => {
  const theme = useTheme()
  const upSm = useMediaQuery(theme.breakpoints.up('sm'))

  return (
    <Box>
      <Box px={2} py={1}>
        <Skeleton variant="rounded" height={upSm ? 70 : 50} />
      </Box>

      <Box p={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Skeleton variant="rounded" height={204} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Skeleton variant="rounded" height={204} />
          </Grid>
        </Grid>
      </Box>

      <Box px={2}>
        <Skeleton variant="rounded" height={204} />
      </Box>

      <Box px={2} pt={2}>
        <Skeleton variant="rounded" height={204} />
      </Box>
    </Box>
  )
}

export default InstallationFormLoadingSkeleton
